// extracted by mini-css-extract-plugin
export default {"wrap":"h5vdWyGLFnBAy3UvOcdK","title":"UkPsxhVSZuQwWyA6CPBD","text":"F34Jg1CMUaRwB8g5xyEn"};